import {
    AD_LISTING_URL_SUFFIX,
    commonUtils,
    COUNTRY_FINLAND_ID,
    COUNTRY_PREFIX,
    LOCALE_CODE_FI,
} from '../../../../common-assets/js/components/common_utils';
import { ACC_TOW_BAR_ID, DRIVE_TYPE_FOUR_WHEEL_ID } from './car_option_interface';
import { searchFormStorage } from '../../../../common-assets/js/components/search/search_form_storage';

const MAKE_BMW_ID = 8;
const MAKE_MERCEDES_BENZ_ID = 45;
const SUB_TYPE_4X4 = 'maasturit';
const SUB_TYPE_4X4_ID = 5;
export const simpleSearch = {
    simpleSearchForm: $('#simple_search'),
    formName: 'simple_search',
    searchFormElement: $('.simpleSearchElement'),
    resetFormElement: $('.grey_reset'),
    dependentSelectElements: ['vehicleType', 'make', 'model', 'region'],
    selectedElementParentClassName: 'form-control__field-is-changed',
    disabledDependentElementName: 'model',
    hideDependentElementTown: 'town',
    hideDependentElementCountry: 'country',
    dataAttributeRequireFieldsName: ['vehicleType'],
    ignoreUrlQueryStringFieldsName: ['make', 'model', 'fuelType', 'submit'],
    currentLocale: commonUtils.getCurrentLocale(),
    modelResetElement: 'model_cross',
    fuelTypeSeoData: {
        1: 'bensiini',
        2: 'diesel',
        4: 'sahko',
        5: 'hybridi',
        6: 'kaasu',
        7: 'e85',
    },
    fuelTypeSeoDataAutot: 'autot',
    redirectUrlVehicleType: {
        13: [`${commonUtils.getAppObject().data('nettikaravaani-url')}/matkailuvaunu/hakutulokset`],
        14: [`${commonUtils.getAppObject().data('nettikaravaani-url')}/matkailuauto/hakutulokset`],
        20: [`${commonUtils.getAppObject().data('nettivaraosa-url')}/listPart.php`],
        21: [`${commonUtils.getAppObject().data('nettimoto-url')}/moottoripyora/hakutulokset`],
        22: [`${commonUtils.getAppObject().data('nettimoto-url')}/moottorikelkka/hakutulokset`],
        23: [`${commonUtils.getAppObject().data('nettivene-url')}/uusimmat`],
        27: [`${commonUtils.getAppObject().data('nettikone-url')}/listMachine.php`],
        28: [
            `${commonUtils.getAppObject().data('nettivaraosa-url')}/simpleSearch.php?status=F&id_part_type=49&id_part_category=118`,
        ],
    },
    // Generate Haku Id if one of these fields selected
    generateSearchHashForFields: [
        'vehicleType',
        'bodyType',
        'fuelType',
        'gearType',
        'kilometersFrom',
        'kilometersTo',
        'yearFrom',
        'yearTo',
        'priceFrom',
        'priceTo',
    ],
    init() {
        this.isLeftSearchFormAvail = Boolean($('.leftSearchForm').length);

        let $body = $('body');
        //  select option change event
        $body.on('change', '.simpleSearchElement', async function () {
            let { value } = this;
            if (this.name === 'vehicleType' && Object.keys(simpleSearch.redirectUrlVehicleType).includes(value)) {
                this.selectedIndex = 0;
                window.open(simpleSearch.redirectUrlVehicleType[value]);
                return;
            }

            await simpleSearch.updateStorageAndSync($(this));
            simpleSearch.processElementChangeEvent(this);
        });

        // reset element click event
        $body.on('click', '.grey_reset', async function () {
            simpleSearch.resetElementEvent(this);

            let elements = this.parentElement.querySelectorAll('select, input');
            // Create an array of promises
            let promises = [];
            for (const element of elements) {
                promises.push(simpleSearch.updateStorageAndSync($(element)));
            }

            // Wait for all promises to complete and then call the counter again after resting fields from above
            await Promise.all(promises);
            // Reset all links
            await simpleSearch.resetAllShowHideLink();
            simpleSearch.getSearchCounter();
        });

        // form submit event
        $body.on('submit', `form[name=${simpleSearch.formName}]`, async function (e) {
            e.preventDefault();

            // Small delay to allow change event to fire for text inputs when Enter is pressed
            // This is specifically for text inputs when user presses Enter key to submit the form,
            // It ensures that the latest value is captured from its change event
            const $activeElement = $(document.activeElement);
            if ($activeElement.is('input[type="text"]') && $activeElement.hasClass('simpleSearchElement')) {
                await new Promise((resolve) => {
                    setTimeout(resolve, 50);
                });
            }

            // If left side search then save search agent data
            if (simpleSearch.isLeftSearchFormAvail) {
                await advanceSearch.saveSearchAgentData(false, true);
                return;
            }

            const form = document.getElementById('simple_search');
            const formData = new FormData(form);
            let hasSelectedFields = simpleSearch.generateSearchHashForFields.some((field) => formData.get(field));

            // Check if any field in formData has a value
            const isFormFieldsEmpty = simpleSearch.isQuickSearchFormFieldsEmpty();

            if (hasSelectedFields || isFormFieldsEmpty) {
                const searchParams = $('#simple_search').serialize();

                // Disable search button
                const $submitButton = $(`form[name=${simpleSearch.formName}] button[type="submit"]`);
                $submitButton.prop('disabled', true);

                $.ajax({
                    url: Routing.generate('generate_search_hash'),
                    type: 'POST',
                    data: searchParams,
                    timeout: 10000, // 10 second timeout
                    success(response) {
                        if (response?.searchHash) {
                            simpleSearch.redirect(response.searchHash);
                        } else {
                            simpleSearch.redirect(); // Fallback to basic redirect
                        }
                    },
                    error() {
                        simpleSearch.redirect();
                    },
                    complete() {
                        // Restore button state
                        $submitButton.prop('disabled', false);
                    },
                });
            } else {
                simpleSearch.redirect();
            }
        });

        $body.on('click', '#resetall', function () {
            simpleSearch.resetAllFilters();

            // Call the counter again after resting fields from above
            searchFormStorage.resetAll().then(() => {
                simpleSearch.getSearchCounter();
            });
        });

        // Allow only numeric input
        $body.on(
            'input',
            '#simple_search #kilometersFrom, #simple_search #kilometersTo, #simple_search #priceFrom, #simple_search #priceTo',
            function () {
                commonUtils.allowInteger($(this));
            }
        );

        // make field select2 event
        this.makeSelect2Event();
        this.modelSelect2Event();
        this.townSelect2Event();

        // Set select2 search box focus for only desktop
        $(document).on('select2:open', () => {
            if (!commonUtils.isDesktopView()) {
                $('.select2-search__field').prop('focus', false);
            }
        });
    },
    processElementChangeEvent(changedElement) {
        this.changeStyleOfSelectedElement(changedElement);

        if ($.inArray(changedElement.id, simpleSearch.dependentSelectElements) !== -1) {
            this.getDependentElements(changedElement);
        } else {
            this.getSearchCounter();
        }
    },
    getSearchCounter() {
        $('.loaderImage').show();

        if (this.isLeftSearchFormAvail) {
            advanceSearch.adCounter();
            return;
        }

        $.get(
            Routing.generate('ajax_search_counter', { formName: simpleSearch.formName }),
            $(`form[name=${simpleSearch.formName}]`).serialize(),
            function (result) {
                $(`form[name=${simpleSearch.formName}]`)
                    .find('.searchCounter')
                    .html(`${Translations.show_result} <span>(${result.total_ads})</span>`);
                $('.loaderImage').hide();
            }
        );
    },
    disableOrHideDependentEmptyElement(elementName) {
        let dependentElement = $(`#simple_search #${elementName}`);
        dependentElement.find('option').not(':first').remove();
        dependentElement.find('optgroup').remove();
        dependentElement.parent().find(this.resetFormElement).hide();

        if (elementName === this.disabledDependentElementName || elementName === 'make') {
            dependentElement.prop('disabled', true);
            $(`.${elementName}Text`).text('');
            dependentElement.closest('li').addClass('disabled-link').removeClass(this.selectedElementParentClassName);
            accessibility.updateDisabledLinkAttributes();
        }
        if ($.inArray(elementName, [this.hideDependentElementTown, this.hideDependentElementCountry]) !== -1) {
            dependentElement.parent().addClass('none');
        }
    },
    getDependentElements(changedElement) {
        let regionTypeValue = simpleSearch.simpleSearchForm.find('#region').val();
        let vehicleTypeId = simpleSearch.simpleSearchForm.find('#vehicleType').val();
        let makeValue = simpleSearch.simpleSearchForm.find('#make').val();
        let modelValue = simpleSearch.simpleSearchForm.find('#model').val();

        let searchFor = simpleSearch.isLeftSearchFormAvail ? 'advanceSearch' : 'quickSearch';
        let params = `changeType=${changedElement.id}&vehicleType=${
            vehicleTypeId
        }&make=${makeValue}&model=${modelValue}&region=${regionTypeValue}&changeFrom=${searchFor}`;

        if (vehicleTypeId === '') {
            params += '&isDisplayMostPopular=true';
        }

        let countryElement = $(`#simple_search #${this.hideDependentElementCountry}`);
        let townElement = $(`#simple_search #${this.hideDependentElementTown}`);
        if (changedElement.id === 'region' && (!regionTypeValue || Number.parseInt(regionTypeValue, 10) === 0)) {
            countryElement.parent().addClass('none');
            countryElement.find('option').not(':first').remove();
            countryElement.next('.grey_reset').hide();
            townElement.parent().addClass('none');
            townElement.find('option').not(':first').remove();
            townElement.next('.grey_reset').hide();
        }

        if (changedElement.id === 'vehicleType') {
            simpleSearch.disableOrHideDependentEmptyElement('make');
            let $model = $(`#${this.modelResetElement}`);
            if ($model.is(':visible')) {
                $(`#${this.modelResetElement}`).click();
                simpleSearch.disableOrHideDependentEmptyElement(this.disabledDependentElementName);
            }
        } else if (changedElement.id === 'make') {
            simpleSearch.disableOrHideDependentEmptyElement(this.disabledDependentElementName);
        }

        $.get(Routing.generate('ajax_get_options'), params, function (response) {
            $.each(response, function (key, value) {
                if (!commonUtils.isObjectEmpty(value)) {
                    if ($(`#simple_search #${key}`).length) {
                        simpleSearch.updateSelectElement(key, value);
                    }
                } else {
                    simpleSearch.disableOrHideDependentEmptyElement(key);
                }
            });
            simpleSearch.getSearchCounter();
        });
    },
    makeSelect2Event() {
        $('#simple_search #make').select2({
            placeholder: Translations.make,
            containerCssClass: 'select2-customization',
            matcher: commonUtils.select2CustomMatchForGroup,
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    modelSelect2Event() {
        $('#simple_search #model').select2({
            placeholder: Translations.model,
            containerCssClass: 'select2-customization',
            matcher: commonUtils.select2CustomMatch,
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    townSelect2Event() {
        $('#simple_search #town').select2({
            placeholder: Translations.town,
            containerCssClass: 'select2-customization',
            matcher: commonUtils.select2CustomMatch,
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    async resetAllShowHideLink() {
        const isEmpty = await searchFormStorage.isSearchEmpty();
        const $resetall = $('#resetall');
        if (isEmpty) {
            $resetall.addClass('disabled-link');
            accessibility.updateDisabledLinkAttributes();
        } else {
            $resetall.removeClass('disabled-link');
            accessibility.updateDisabledLinkAttributes();
        }
    },
    resetAllFilters() {
        $('.vehicleTypeMultiple, .bodyTypeMultiple, .makeMultiple, .fuelTypeMultiple, .locationMultiple').addClass(
            'none'
        );
        $(
            '.vehicleTypeSingle, .bodyTypeSingle, .makeSingle, .modelSingle, .fuelTypeSingle, .locationSingle, .townSingle, .countrySingle'
        ).removeClass('none');
        $(':input', `#${this.formName}`)
            .not(':hidden, :button, :submit, :reset, :checkbox, :radio')
            .val('')
            .prop('selected', false);
        $(':checkbox', `#${this.formName}`).prop('checked', false);
        $(`#${this.formName} .grey_reset`).hide();
        $(`#${this.formName} .form-control__with-reset`)
            .not('.vehicleTypeMultiple, .bodyTypeMultiple, .makeMultiple, .fuelTypeMultiple, .locationMultiple')
            .removeClass(this.selectedElementParentClassName);
        $("#simple_search div[class$='Text']").text('');
        $('#resetall').addClass('disabled-link');
        accessibility.updateDisabledLinkAttributes();
        this.resetElementEvent($('#simple_search #vehicleType')[0]);
        this.resetElementEvent($('#simple_search #region')[0]);

        // If search model is available then reset model
        if ($('#advance_search .resetWholeAdvSearchFields').length) {
            $('#advance_search .resetWholeAdvSearchFields').trigger('click');
        }
    },
    changeStyleOfSelectedElement(element) {
        // on select box change event changed style for selected element and display reset option
        const childElements = element.closest('li').querySelectorAll('select, input');
        // This element exist in home page
        const elementTextClass = $(`.${element.name}Text`);
        const isCheckbox = element.type === 'checkbox';
        const isCheckedOrFilled = isCheckbox ? element.checked : $.trim(element.value) !== '';

        if (isCheckedOrFilled) {
            elementTextClass.text($(`#${element.name} option:selected`).text());
            element.closest('li').classList.add(simpleSearch.selectedElementParentClassName);
            this.showResetOption(element);
        } else {
            if (isCheckbox) {
                let isAnyChecked = true;
                if (childElements.length > 1) {
                    $.each(childElements, function (key) {
                        if (childElements[key].checked) {
                            isAnyChecked = false;
                        }
                    });
                }

                if (isAnyChecked) {
                    element.closest('li').classList.remove(this.selectedElementParentClassName);
                }
            } else {
                elementTextClass.text('');

                // Check if we should remove parent class (only for non-checkbox elements)
                let isRemoveParentClass = true;
                if (childElements.length > 1) {
                    $.each(childElements, function (key) {
                        if (childElements[key].value !== '') {
                            isRemoveParentClass = false;
                        }
                    });
                }

                if (isRemoveParentClass) {
                    element.closest('li').classList.remove(this.selectedElementParentClassName);
                }
            }

            this.hideResetOption(element);
        }

        this.resetAllShowHideLink();
    },
    hideResetOption(changedElement) {
        let element = $(`#${changedElement.id}`);
        let total = element.closest('li').find('select,input').length;
        let hideReset =
            2 === total
                ? element.closest('li').find('select,input')[0].value === '' &&
                  element.closest('li').find('select,input')[1].value === ''
                : true;
        if (hideReset) {
            element.closest('li').find(this.resetFormElement).hide();
        }
    },
    showResetOption(changedElement) {
        let el = $(`#${changedElement.id}`);
        if (el[0].selectedIndex > 0 || (el[0].type === 'text' && $.trim(el.val()) !== '')) {
            el.closest('li').find(this.resetFormElement).show();
        }
    },
    resetElementEvent(resetElement) {
        let element = resetElement.parentElement.querySelectorAll('select, input');
        $.each(element, function (key) {
            if (element[key].type === 'select-one') {
                element[key].selectedIndex = 0;
                // Reset select2 element text
                if (element[key].name === 'make') {
                    simpleSearch.makeSelect2Event();
                } else if (element[key].name === 'model') {
                    simpleSearch.modelSelect2Event();
                }
                let firstRangeDependentElement = $(`#${element[0].id}`);
                if (
                    element.length === 2 &&
                    key === 0 &&
                    typeof firstRangeDependentElement.attr('onchange') !== 'undefined'
                ) {
                    // Trigger the change event instead of eval
                    firstRangeDependentElement.trigger('change');
                }
            } else {
                element[key].value = '';
            }
        });

        // hide reset option after reset select, input value or index
        this.hideResetOption(resetElement);

        // get dependent option after reset value
        this.processElementChangeEvent(element[0]);
    },
    updateSelectElement(id, optionsData) {
        let selectElement = $(`#simple_search #${id}`);
        let selectedValue = selectElement.val();
        let selected = '';
        let countryElement = $(`#simple_search #${this.hideDependentElementCountry}`);
        let townElement = $(`#simple_search #${this.hideDependentElementTown}`);
        // Remove current options except first
        selectElement.find('option').not(':first').remove();
        selectElement.find('optgroup').remove();
        selectElement.prop('disabled', false);

        if (id === this.hideDependentElementTown) {
            countryElement.parent().addClass('none');
            countryElement.find('option').not(':first').remove();
            countryElement.next('.grey_reset').hide();
        } else if (id === this.hideDependentElementCountry) {
            townElement.parent().addClass('none');
            townElement.find('option').not(':first').remove();
            townElement.next('.grey_reset').hide();
        }

        $.each(optionsData, function (key, value) {
            if (typeof value !== 'object') {
                // Special case for BMW series model: Remove underscore from key because it added for sorting issue
                const localKey = id === 'model' ? key.replace('_', '') : key;
                selected = value === selectedValue ? 'selected' : '';
                selectElement.append(`<option value="${value}" ${selected}>${localKey}</option>`);
            } else if ($.inArray(id, simpleSearch.dataAttributeRequireFieldsName) !== -1) {
                selected = value.id === selectedValue ? 'selected' : '';
                selectElement.append(
                    `<option value="${value.id}" data-seo-name="${value[LOCALE_CODE_FI]}"${selected}>${value[simpleSearch.currentLocale]}</option>`
                );
            } else {
                simpleSearch.updateOptGroupOptions(id, key, value);
            }
        });

        // Add and remove "none" class for town and country element instead of hide/show
        if (
            id === 'model' ||
            id === simpleSearch.hideDependentElementTown ||
            id === simpleSearch.hideDependentElementCountry
        ) {
            selectElement.parent().removeClass('none');
        }

        // Remove class for model select element
        selectElement.prop('disabled', false);
        selectElement.closest('li').removeClass('disabled-link');
        accessibility.updateDisabledLinkAttributes();
        this.changeStyleOfSelectedElement(selectElement[0]);
    },
    updateOptGroupOptions(elementId, optGroupLabel, optGroupData) {
        let selectElement = $(`#simple_search #${elementId}`);
        let selectElementValue = selectElement.val();
        let selected = '';

        let $optgroup = $(`<optgroup label="${optGroupLabel}">`);
        $.each(optGroupData, function (optGroupKey, optGroupValue) {
            selected = optGroupValue === selectElementValue ? 'selected' : '';
            $optgroup.append(`<option value="${optGroupValue}" ${selected}>${optGroupKey}</option>`);
        });

        selectElement.append($optgroup);
    },
    redirect(searchHash = '') {
        let form = $(`form[name=${simpleSearch.formName}]`)[0];
        let fuelType = form.elements.fuelType.options[form.elements.fuelType.selectedIndex];
        let make = form.elements.make.options[form.elements.make.selectedIndex];
        let model = form.elements.model.options[form.elements.model.selectedIndex];
        let i = 1;
        let params = {};

        if (make.value) {
            params[`arg${i}`] = commonUtils.formatUri(make.text);
            i++;
        }
        if (model.value) {
            // replace `.` to `-` for model names like 3.5,3.0
            let modelText = model.text.replace(/\./g, '-');
            if ($.inArray(Number.parseInt(make.value, 10), [MAKE_MERCEDES_BENZ_ID, MAKE_BMW_ID]) !== -1) {
                modelText = modelText.replace(/\s\(All\)/gi, '').replace(/\s\(kaikki\)/gi, '');
            }
            params[`arg${i}`] = commonUtils.formatUri(modelText);
            i++;
        } else if (
            make.value &&
            !(fuelType.value in this.fuelTypeSeoData) &&
            SUB_TYPE_4X4_ID ===
                Number.parseInt(form.elements.bodyType.options[form.elements.bodyType.selectedIndex].value, 10)
        ) {
            // Make selected but model or fuel type not selected then if boat type is 4X4 then make + body type in seo url
            params[`arg${i}`] = commonUtils.formatUri(SUB_TYPE_4X4);
            i++;
        }

        if (fuelType.value in this.fuelTypeSeoData) {
            // When make or modal not selected then Fuel type in seo url
            if (i === 1) {
                let fuelTypeValue = fuelType.value;
                let seoText = this.fuelTypeSeoData[fuelTypeValue];
                let fuelTypeSeo =
                    '7' === fuelTypeValue
                        ? `${seoText}-${this.fuelTypeSeoDataAutot}`
                        : seoText + this.fuelTypeSeoDataAutot;

                params[`arg${i}`] = AD_LISTING_URL_SUFFIX;
                i++;
                params[`arg${i}`] = commonUtils.formatUri(fuelTypeSeo);
                i++;
            } else {
                // When make is selected but modal not then make and fuel type in seo url
                params[`arg${i}`] = commonUtils.formatUri(this.fuelTypeSeoData[fuelType.value]);
                i++;
            }
        } else {
            const index = this.ignoreUrlQueryStringFieldsName.indexOf('fuelType');
            this.ignoreUrlQueryStringFieldsName.splice(index, 1);
        }

        // seo url has minimum two values if it is less, than add default suffix "vaihtoautot"
        if (2 >= i) {
            params[`arg${i}`] = AD_LISTING_URL_SUFFIX;
        }

        let url = Object.keys(params).length ? Routing.generate('ad_listing', params) : '';
        url = url.replaceAll(/\s/g, '-').toLowerCase();

        // Redirect to SEO based url with haku id
        if (url && searchHash) {
            url = `${url}?haku=${searchHash}`;
        } else if (searchHash) {
            url = Routing.generate('advance_search_list', { haku: searchHash });
        }

        globalThis.location.href = url;
    },
    isQuickSearchFormFieldsEmpty() {
        let isFormSelectionEmpty = true;
        $('#simple_search')
            .find('input, select')
            .each(function () {
                if (this.value.trim() !== '') {
                    isFormSelectionEmpty = false;
                    return false;
                }
                return true;
            });

        return isFormSelectionEmpty;
    },
    // Update a field value in storage
    async updateStorageAndSync($field) {
        let isRemove = false;
        let fieldName = $field.attr('name');
        let fieldValue = $field.val();

        // Special case for slider elements
        // When change value from slider it triggers change event of "from" element, So it require to sync "to" element
        // i.e. searchYearSlider.fromElement.trigger('change'); OR searchPriceSlider.fromElement.trigger('change');
        if (['priceFrom', 'kilometersFrom'].includes(fieldName)) {
            let toField = fieldName.replace('From', 'To');
            await searchFormStorage.updateField(toField, this.simpleSearchForm.find(`[name="${toField}"]`).val());
        }

        if (fieldName === 'vehicleType') {
            fieldValue = fieldValue ? [fieldValue] : [];
            // Remove makeModel from storage if vehicle type is changed
            await searchFormStorage.updateField('makeModels', {});
        } else if (fieldName === 'make' || fieldName === 'model') {
            fieldValue = this.handleMakeModel($field, fieldName, fieldValue);
            // Update field name
            fieldName = 'makeModels';
        } else if (fieldName === 'region' || fieldName === 'town' || fieldName === 'country') {
            fieldValue = this.handleLocationFields($field, fieldName, fieldValue);
            // Update field name
            fieldName = 'locations';
        } else if (fieldName === 'bodyType' || fieldName === 'fuelType') {
            fieldValue = fieldValue ? [fieldValue] : [];
        } else if (fieldName === 'driveTypeFourWheel') {
            fieldName = 'driveType';
            fieldValue = await this.handleCheckboxFieldForMultipleOptions($field, fieldName, DRIVE_TYPE_FOUR_WHEEL_ID);
            if (fieldValue.length < 1) {
                isRemove = true;
            }
        } else if (fieldName === 'accessoriesTowBar') {
            fieldName = 'accessories';
            fieldValue = await this.handleCheckboxFieldForMultipleOptions($field, fieldName, ACC_TOW_BAR_ID);
            if (fieldValue.length < 1) {
                isRemove = true;
            }
        }

        if (fieldValue === '') {
            isRemove = true;
        }

        return isRemove
            ? searchFormStorage.deleteField(fieldName)
            : searchFormStorage.updateField(fieldName, fieldValue);
    },
    async handleCheckboxFieldForMultipleOptions($field, fieldName, fieldValue) {
        const formData = await searchFormStorage.getFormData();

        // Get value from storage and append or remove into array
        let storedValue = formData[fieldName] ? formData[fieldName] : [];
        if ($field.is(':checked')) {
            storedValue.push(fieldValue);
        } else {
            // Remove value from array, Keep loose comparison to avoid type issues
            storedValue = storedValue.filter((value) => value !== fieldValue);
        }

        return storedValue;
    },
    handleMakeModel($field, fieldName, fieldValue) {
        const $model = this.simpleSearchForm.find('#model');
        const $make = this.simpleSearchForm.find('#make');
        let keyMakeModel = '';
        let valueMakeModel = '';
        let localFieldValue = fieldValue;
        if (fieldName === 'model') {
            keyMakeModel = $make.val();
            valueMakeModel = $make.find('option:selected').text().trim();
            if ($model.val()) {
                keyMakeModel = `${keyMakeModel},${$model.val()}`;
                valueMakeModel = `${valueMakeModel} ${$model.find('option:selected').text().trim()}`;
            }
            localFieldValue = { [keyMakeModel]: valueMakeModel.trim() };
        } else if (fieldName === 'make') {
            if ($make.val()) {
                keyMakeModel = $make.val();
                valueMakeModel = $make.find('option:selected').text().trim();
                localFieldValue = { [keyMakeModel]: valueMakeModel.trim() };
            } else {
                localFieldValue = {};
            }
        }

        return localFieldValue;
    },
    handleLocationFields($field, fieldName, fieldValue) {
        let key = '';
        let value = '';
        let localFieldValue = fieldValue;
        if (fieldName === 'country') {
            localFieldValue = { [COUNTRY_PREFIX + localFieldValue]: $field.find('option:selected').text().trim() };
        } else if (fieldName === 'town') {
            key = $('#simple_search #region').val() + (localFieldValue ? `,${localFieldValue}` : '');
            value =
                $('#simple_search #region :selected').text() +
                (localFieldValue ? ` ${$('#simple_search #town :selected').text()}` : '');
            localFieldValue = { [key]: value.trim() };
        } else if (fieldName === 'region') {
            if (localFieldValue === '0') {
                localFieldValue = {
                    [COUNTRY_PREFIX + COUNTRY_FINLAND_ID]: $field.find('option:selected').text().trim(),
                };
            } else if (Number.parseInt(localFieldValue, 10) > 0) {
                localFieldValue = { [localFieldValue]: $field.find('option:selected').text().trim() };
            }
        }

        return localFieldValue;
    },
};
